import { render } from "./size-guide.vue?vue&type=template&id=5c3c3662"
import script from "./size-guide.vue?vue&type=script&lang=js"
export * from "./size-guide.vue?vue&type=script&lang=js"

import "./size-guide.vue?vue&type=style&index=0&id=5c3c3662&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__